import { ThemeProvider, theme, Box } from "@chakra-ui/react";
import Footer from "./footer";
import Header from "./header";

import React, { useState, useEffect } from "react";
import { GetCookie } from "../provider/common";

export default function BaseLayout({ children }) {
  const [isLogin, setIsLogin] = useState(0);

  useEffect(() => {
    checkLogin();
  }, []);

  const checkLogin = async () => {
    const loginInfo = await GetCookie("isLogin");
    setIsLogin(loginInfo);
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        {/* 화면이 길이 지면 푸터를 하단으로 배치하기 위함 */}
        <Box display="flex" flexDirection="column" minHeight="100vh">
          <Header />
          {/* 메인 영역이 화면의 빈공간을 차지하도록 조건 flex=1 */}
          <Box as="main" flex="1">
            {children}
          </Box>
          <Footer />
        </Box>
      </ThemeProvider>
    </>
  );
}
